/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { FC } from 'react';
import { FooterAdsBannerBlock } from '../../models/homepageBlockTypes';
import { View } from 'react-native';
import { useFlagEnabled } from '@airasia-rn/account';
import { FEATURE_FLAG_HOME_ENABLE_ADS_RENDER } from '../../constants';
import HomeWebAd from '../WebAds/HomeWebAd';
import { styles } from './FooterAdsBannnerView.styles';
import { useDeviceInfo } from '@airasia-rn/ui';

interface FooterAdsBannerViewProps {
  item: FooterAdsBannerBlock;
}

const FooterAdsBannerView: FC<FooterAdsBannerViewProps> = ({ item }) => {
  const { enabled: isAdsRenderEnabled } = useFlagEnabled(
    FEATURE_FLAG_HOME_ENABLE_ADS_RENDER,
  );
  const { width } = useDeviceInfo();

  if (!isAdsRenderEnabled) return null;

  const banners = item.data.banners;

  const showHorizontalAds = width >= 1500 && banners.length >= 2;

  return (
    <View
      style={
        showHorizontalAds
          ? styles.footerAdsContainerWeb
          : styles.footerAdsContainerMobile
      }
    >
      {banners.map((banner, index) => {
        const isLeft = index % 2 === 0;
        const isLastItem = index === banners.length - 1;

        return (
          <View
            key={`${item.id}-${index}`}
            style={[
              !showHorizontalAds && styles.footerAdsItemMobile,

              showHorizontalAds && {
                flex: 1,
                marginRight: isLeft ? styles.footerAdsMargin.gap : 0,
              },
              !showHorizontalAds &&
                !isLastItem && { marginBottom: styles.footerAdsMargin.gap },
            ]}
          >
            <HomeWebAd
              slotId={`${item.id}-${index}`}
              adUnit={banner.adUnitId}
              isFooterAds={true}
              collapseUntilRendered={true}
            />
          </View>
        );
      })}
    </View>
  );
};

export default FooterAdsBannerView;
